import layout from '@/layout';
import base from './moudles/baseData';
import business from './moudles/business';
import platform from './moudles/platform';
import report from './moudles/report';
import system from './moudles/system';

/* 路由api */
import routerMap from './routerMap.js';
/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'home' },
    component: layout,
    children: [
      // 首页
      {
        path: '/',
        name: 'home',
        meta: {auth: true,title:"首页"},
        component:routerMap.home
      },
      {
        path:"/noauth",
        name:"no-auth-user",
        component:routerMap.noAuthUser,
        meta:{
          title:"用户未授权",
          hidden:true
        }
      },

    ]
  },
  base,
  business,
  report,
  system,
  platform
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: routerMap.login
  }
]

/**
 * 错误页面
 */
const errorPage = [
  {
    path: '*',
    name: '404',
    component: routerMap.notFind
  }
]


// 导出需要显示菜单的
//export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]
